import { doc, getDoc } from 'firebase/firestore';
import { DEFAULT_TENANT_ID, type InterestTagConfig } from '@kawai/shared';
import { db } from '../firebase.js';

const COL = 'promo_interest_tag_configs';

/**
 * M-62: 自テナントの興味タグ設定（1 テナント 1 doc）を取得する。未作成なら null。
 *
 * Firestore Rules `promo_interest_tag_configs/{tenantId}` の read は admin + promo 契約自テナント。
 * doc id = tenantId 固定なので index 不要（promoPlans と同方針）。
 */
export async function fetchInterestTagConfig(
  tenantId: string = DEFAULT_TENANT_ID,
): Promise<InterestTagConfig | null> {
  const tid = tenantId || DEFAULT_TENANT_ID;
  const snap = await getDoc(doc(db, COL, tid));
  return snap.exists() ? (snap.data() as InterestTagConfig) : null;
}
